import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

// Private pages: a session is required and its email must be verified
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) return router.createUrlTree(['/login']);
  if (!auth.isEmailVerified()) return router.createUrlTree(['/verify-email']);
  return true;
};

// Public auth pages (login, register…): a logged-in user is sent wherever their session belongs
export const publicGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) return true;
  return router.createUrlTree([auth.isEmailVerified() ? '/home' : '/verify-email']);
};

// The waiting screen: only for a stored session that is still unverified
export const unverifiedGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) return router.createUrlTree(['/login']);
  if (auth.isEmailVerified()) return router.createUrlTree(['/home']);
  return true;
};
